<template>
    <div v-if="show">
        <div class="modal-vue--overlay modal-vue--high-zindex d-flex" @click.self="closeModal()">
            <div class="reorder-modal-vue reorder-modal-vue--scroll mx-auto my-auto">
                <div class="reorder-modal-vue__top d-flex align-items-center">
                    <div class="reorder-modal-vue__top--title font-weight-bold text-danger">{{ $t("myAccount.reorderModalSorry") }}</div>
                    <span @click="closeModal" class="text-right ml-auto cursor-pointer"><i class="fas fa-times text--border-green"></i></span>
                </div>
                <div class="reorder-modal-vue__content">
                    <div class="mb-4" v-for="(unavailableProduct, index) in reorderError.not_found">
                        <template v-if="index === notFoundIndex">
                            <div class="reorder-modal-vue__content--top">
                                <div class="row no-gutters bg-green-100">
                                    <div class="col-9">
                                        <div class="font-weight-bold mb-3" v-text="unavailableProduct.name"></div>
                                        <div class="text-danger">{{ $t("myAccount.reorderModalPackaging") }}<span class="font-weight-bold">{{ $t("myAccount.reorderModalOutOfStock") }}</span></div>
                                        <ul>
                                            <li>{{ unavailableProduct.attribute_group_name }} : <strong>{{ unavailableProduct.attribute_name }}</strong></li>
                                        </ul>

                                    </div>
                                    <div class="col-3">
                                        <a :title="unavailableProduct.name" class="account__link" :href="unavailableProduct.product_link">
                                            <img class="image--full-width"
                                                 :src="unavailableProduct.image_link"
                                                 alt="">
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="reorder-modal-vue__content--bottom">
                                <div v-if="unavailableProduct.alternatives.length > 0" class="text--green py-3 px-2">{{ $t("myAccount.reorderModalAlternativesInStock") }}:</div>
                                <div v-if="unavailableProduct.alternatives.length > 0">

                                    <div v-for="(alternativeProduct, index) in unavailableProduct.alternatives">
                                        <div class="d-flex align-items-center text-right account--text ml-auto px-2">
                                            <div class="reorder-modal-vue__product-select d-flex align-items-center w-100 mr-3">
                                                <!-- todo shorter variable for package size (attribute_name too long) -->
                                                <div class="account--text text-left mr-2">{{ alternativeProduct.attribute_name }}</div>
                                                <div class="account--text ml-auto">
                                                    <div class="reorder-modal-vue__alternative-card text--gray text-nowrap">
                                                        <div class="mr-2 text-left">
                                                            <div class="reorder-modal-vue__alternative-card--margin-bottom">
                                                                <del v-if="compareString(alternativeProduct.price_from_display, alternativeProduct.price_for_display)">{{ alternativeProduct.price_from_display }}</del>
                                                                <div class="text--black" v-else>{{ alternativeProduct.price_from_display }}</div>
                                                            </div>
                                                            <div v-if="!isMobile">{{ alternativeProduct.price_pkilo_from }}</div>
                                                        </div>
                                                        <div v-if="compareString(alternativeProduct.price_from_display, alternativeProduct.price_for_display)" class="text-left">
                                                            <div class="text-danger reorder-modal-vue__alternative-card--margin-bottom">{{ alternativeProduct.price_for_display }}</div>
                                                            <div v-if="!isMobile">{{ alternativeProduct.price_pkilo_for }}</div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div class="ml-auto mr-3">
                                                <select v-model="alternativeProduct.quantity" class="input-select input-select--number mr-3 cursor-pointer account--text p-2" id="numbers">
                                                    <option v-for="i in 20" :value="i">{{ i }}</option>
                                                </select>
                                            </div>
                                            <button class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600" @click="addProductToReorder(alternativeProduct)"><i class="fas fa-shopping-cart"></i></button>
                                        </div>

                                        <div v-if="index < unavailableProduct.alternatives.length - 1 && isMobile" class="account__border pb-2 mb-2"></div>
                                    </div>
                                </div>
                                <div
                                    class="reorder-modal-vue__content--top"
                                    v-html="unavailableProduct.reorder_unavailable_message"
                                    v-else-if="unavailableProduct.reorder_unavailable_message !== null"
                                >
                                </div>
                                <!-- todo translation missing for text under this line -->
                                <!-- <div class="text-danger" v-else >{{ $t("myAccount.noAltertiveProducts") }}</div>-->
                            </div>
                        </template>
                    </div>

                    <slot></slot>
                </div>

                <div class="reorder-modal-vue__bottom">

                    <div class="d-flex flex-col justify-content-end py-3 reorder-modal-vue__bottom--inner">
                        <div class="mr-2 d-flex align-items-center">{{ $t("myAccount.reorderModalSkip") }}</div>
                        <div>
                            <button class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600" @click="nextAlternativeProduct"><i class="fas fa-times"></i></button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReorderModal",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            isMobile: Boolean,
            orderId: 0,
            originalProducts: {},
            reorderError: {},
        },
        data() {
            return {
                count: 0,
                chosenProducts: [],
                notFoundIndex: 0,
            }
        },
        methods: {
            updateCart() {
                window.EventBus.$emit('update-cart');
            },
            closeModal() {
                document.body.classList.remove("modal-vue--open");
                document.body.classList.remove("modal-vue--high-zindex");
                this.$emit('close');
                this.chosenProducts = [];
            },
            addProductToReorder(product) {
                if (product.quantity <= 0) {
                    return;
                }

                let foundItem = this.chosenProducts.find((chosenProduct) => {
                    return (
                        parseInt(chosenProduct.id_product) === parseInt(product.id_product)
                        && parseInt(chosenProduct.id_product_attribute) === parseInt(product.id_product_attribute)
                    )
                });
                if (typeof foundItem === 'undefined') {
                    this.chosenProducts.push({ ...product });
                } else {
                    foundItem.quantity += product.quantity;
                }
                this.nextAlternativeProduct();
            },
            removeProductFromReorder(productId, productAttributeId) {
                this.chosenProducts = this.chosenProducts.filter((chosenProduct) => {
                    return !(
                        parseInt(chosenProduct.id_product) === parseInt(productId)
                        && parseInt(chosenProduct.id_product_attribute) === parseInt(productAttributeId)
                    )
                })
            },
            changeProductQuantity(product, operator, place = 'alternatives') {
                if (operator === 'up') {
                    product.quantity++;
                } else if (operator === 'down') {
                    product.quantity--;

                    if (product.quantity === 0 && place === 'chosen-products') {
                        this.removeProductFromReorder(product.id_product, product.id_product_attribute);
                    }

                    if (product.quantity < 0) {
                        product.quantity = 0;
                    }
                }
            },
            reorderUpdatedList() {
                if (this.chosenProducts.length === 0) {
                    this.closeModal();
                    return;
                }

                jQuery.ajax('/module/brekz_reorder/ajax', {
                    type: "POST",
                    data: {
                        id_order: this.orderId,
                        products: this.chosenProducts
                    },
                    success: response => {
                        let responseDecoded = JSON.parse(response);

                        if (responseDecoded.success) {
                            // window.location.replace(responseDecoded.link);
                            this.updateCart();
                            this.closeModal();
                            this.$emit('list-updated');
                            this.chosenProducts = [];
                            this.notFoundIndex = 0;
                        }

                        this.isLoading = false;
                    },
                    error: XMLHttpRequest => {
                        this.isLoading = false;
                        this.showErrorModal = true;
                        console.log('reorder call failed', XMLHttpRequest.responseText);
                    }
                });
            },
            calculateProductsToReorder() {
                if (!this.originalProducts) {
                    return;
                }

                let productsToAdd = this.originalProducts.filter((originalProduct) => {
                    let foundItem = this.reorderError.not_found.find((unavailableProduct) => {
                        return (
                            parseInt(unavailableProduct.id_product) === parseInt(originalProduct.id_product)
                            && parseInt(unavailableProduct.id_product_attribute) === parseInt(originalProduct.id_product_attribute)
                        )
                    });
                    return typeof foundItem === 'undefined';
                });

                this.chosenProducts = this.chosenProducts.concat(productsToAdd);
            },
            compareString( string1, string2 ) {
                let result  = string1.localeCompare(string2);

                return result;
            },
            nextAlternativeProduct() {
                if (this.reorderError.not_found.length -1 > this.notFoundIndex){
                    this.notFoundIndex ++;
                }
                else {
                    this.reorderUpdatedList();

                }
            }
        },
        watch: {
            show: function (shown) {
                if (shown) {
                    this.calculateProductsToReorder();
                }
            },
        },
    }
</script>
